import { axiosV2 } from 'interceptors/axios';
import { Dispatch } from 'redux';
import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

type GetOperationParticipantsProps = {
  operationId: string;
  params?: any;
};

export const getOperationParticipants =
  ({ operationId, params }: GetOperationParticipantsProps) =>
  async (dispatch: Dispatch) => {
    const query = { params: { operationId, ...params } };

    try {
      const { data } = await axiosV2.get('/operations/participants', query);
      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
